<template>
  <div class="container">
    <div class="section">
      <div class="row">
        <div class="col-sm-12 top-buffer">
          <adsense class="adsbygoogle" ad-client="ca-pub-1632304178786452" ad-slot="8387166617" ad-style="display: block" ad-format="auto"></adsense>
          <h3 class="heading">LUNAR FISHING CALENDAR</h3>
          <p>Enter your zipcode below for the best times to fish according to our solunar forecast. The charts will show major
            and minor feeding times, plus sunrise and sunset data so that you can plan your fishing trip accordingly.</p>
          <div class="input-group">
            <input type="number" title="Enter Zipcode for Lunar Fishing Calendar" style="font-size: 16px;" id="zipCode" v-model="zipcode"
              class="form-control" @keypress.enter="getZipCodeChart" placeholder="Enter Zip Code" aria-describedby="basic-addon2">
            <span title="Get Lunar Fishing Calendar" class="input-group-addon sbt" @click="getZipCodeChart" id="getChart">GET CHART</span>
          </div>
          <div v-if="invalidZipcode">
            <div class="alert alert-danger top-buffer" role="alert">Please enter a valid 5 digit Zipcode and resubmit</div>
          </div>
        </div>
        <div v-if="showChartSections" class="col-sm-12 top-buffer">
          <div class="panel panel-default" :class="{opaque: loading}" style="height: 316px;">
            <div class="panel-heading">
              <h5>
                <b>Predictions for {{city}}, {{state}}</b>
              </h5>
            </div>
            <div class="panel-body">
              <div class="btn-group" role="group">
                <button type="button" class="btn btn-sm btn-primary" disabled="disabled">{{monthName}}</button>
                <button type="button" class="btn btn-sm btn-default" @click="goToNextMonth(chart)" id="nextMonthButton">Next Month
                  <span class="glyphicon glyphicon-chevron-right"></span>
                </button>
              </div>
              <div class="btn-group" role="group">
                <button type="button" class="btn btn-sm btn-primary" disabled="disabled" id="currentYearButton">{{year}}</button>
                <button type="button" class="btn btn-sm btn-default" @click="goToNextYear(chart)" id="nextYearButton">{{year + 1}}</button>
              </div>
              <div class="img-responsive" id="curve_chart">
                <div v-if="loading" class="text-center top-buffer" id="chartSection">
                  <icon name="circle-o-notch" scale="4" spin></icon>
                </div>
                <vue-chart v-if="!reloading" :columns="columns" :rows="rows" :options="options" :chart-events="chartEvents" ref="googleChart"></vue-chart>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showChartSections" class="col-sm-12" id="dayChartSection">
          <div class="panel panel-default" id="dayChartSection" :class="{opaque: loading}">
            <div class="panel-heading">
              <h5>
                <b>{{selectedDay}}</b>
              </h5>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-sm-4">
                  <div class=" panel panel-primary ">
                    <div class="panel-heading text-center">Fish Activity Rating
                      <h2>{{selectedRating}}</h2>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class=" panel panel-default">
                    <div class="panel-body">
                      <table class="table">
                        <tbody>
                          <tr>
                            <td>Sunrise</td>
                            <td>{{selectedSunrise}}</td>
                          </tr>
                          <tr>
                            <td>Sunset</td>
                            <td>{{selectedSunset}}</td>
                          </tr>
                          <tr>
                            <td>Major Feeding Times</td>
                            <td>{{majorFeedingTimeOne}}
                              <br>{{majorFeedingTimeTwo}}</td>
                          </tr>
                          <tr>
                            <td>Minor Feeding Times</td>
                            <td>{{minorFeedingTimeOne}}
                              <br>{{minorFeedingTimeTwo}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class=" panel panel-default">
                    <div class="panel-body text-center">
                      <img src="../assets/moon11.gif" class="center-block img-responsive">Moon Illumination
                      <h4>{{moonIllumination}}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  // import moment from 'moment'
  export default {
    name: 'ZipcodeChart',
    data() {
      return {
        zipcode: '',
        loading: true,
        reloading: true,
        showChartSections: false,
        city: '',
        state: '',
        chart: {},
        year: '',
        month: '',
        monthName: '',
        monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
          'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'
        ],
        selectedDay: '',
        selectedRating: '',
        selectedSunrise: '',
        selectedSunset: '',
        majorFeedingTimeOne: '',
        majorFeedingTimeTwo: '',
        minorFeedingTimeOne: '',
        minorFeedingTimeTwo: '',
        moonIllumination: '',
        chartEvents: {
          'select': () => {
            let chart = this.$refs.googleChart.chart
            let selection = chart.getSelection()
            this.setDaySection(selection[0].row, this.chart)
          },
          'ready': () => {
            this.loading = false
            this.selectToday(this.chart)
          }
        },
        columns: [{ type: 'date', label: 'Day' },
        { type: 'number', label: 'Rating' }
        ],
        rows: [],
        options: {},
        invalidZipcode: false
      }
    },
    methods: {
      initialize() {
        this.loading = true
        this.reloading = true
        this.zipcode = this.$route.params.zipcode
        let d = new Date()
        this.year = d.getFullYear()
        this.monthName = this.monthNames[d.getMonth()]
        if (this.validate(this.zipcode)) {
          this.showChartSections = true
          axios.get(this.getBaseUrl() + '/chartByZipCode?zip=' + this.zipcode).then((response) => {
            this.chart = response.data
            this.city = this.chart.zipCodeHit.city
            this.state = this.chart.zipCodeHit.state
            this.monthName = this.chart.moonTimes[0].strMonth
            this.year = this.chart.moonTimes[0].year
            this.$nextTick(() => {
              this.options = this.getOptions(this.chart)
              this.rows = this.getRows(this.chart)
              this.reloading = false
            })
          }).catch((error) => {
            console.log(error)
          })
        }
      },
      getZipCodeChart() {
        this.$router.push('/lunar-fishing-calendar/' + this.zipcode)
      },
      validate(zip) {
        if (!zip) {
          return false
        }
        if (zip.length !== 5) {
          this.invalidZipcode = true
          return false
        }
        this.invalidZipcode = false
        return true
      },
      getBaseUrl() {
        let baseUrl = ''
        if (process.env.NODE_ENV === 'development') {
          baseUrl = 'http://localhost:8080'
        }
        return baseUrl
      },
      getRows(chartData) {
        let rows = []
        let length = chartData.moonTimes.length
        for (let i = 0; i < length; i++) {
          let mt = chartData.moonTimes[i]
          rows.push([new Date(mt.year, mt.month - 1, mt.day), mt.rating])
        }
        return rows
      },
      getOptions(chartData) {
        this.monthName = chartData.moonTimes[0].strMonth
        this.month = chartData.moonTimes[0].month
        this.year = chartData.moonTimes[0].year

        return {
          curveType: 'function',
          legend: { position: 'none' },
          vAxis: {
            maxValue: 45,
            title: 'Fish Activity Ratings',
            textPosition: 'in',
            gridlines: { color: 'transparent' }
          },
          hAxis: {
            allowContainerBoundaryTextCufoff: true,
            showTextEvery: 1,
            maxTextLines: 1,
            maxAlternation: 1,
            minTextSpacing: 0,
            viewWindowMode: 'maximized',
            ticks: [
              { v: new Date(this.year, this.month - 1, 1), f: this.monthName + ' 1' },
              { v: new Date(this.year, this.month - 1, 7), f: '7' },
              { v: new Date(this.year, this.month - 1, 14), f: '14' },
              { v: new Date(this.year, this.month - 1, 21), f: '21' },
              { v: new Date(this.year, this.month - 1, 28), f: '28' }
            ]
          },
          chartArea: {
            left: 18,
            width: '100%',
            height: '80%'
          },
          axisTitlesPosition: 'in'
        }
      },
      selectToday(chartData) {
        let chart = this.$refs.googleChart.chart
        let today = new Date().getDate() - 1
        if (new Date().getMonth() === chartData.moonTimes[0].month - 1) {
          chart.setSelection([{ row: today, column: 1 }])
          this.setDaySection(today, chartData)
        } else {
          chart.setSelection([{ row: 0, column: 1 }])
          this.setDaySection(0, chartData)
        }
      },
      setDaySection(selectedDay, chartData) {
        let mt = chartData.moonTimes[selectedDay]
        this.selectedDay = this.monthName + ' ' + (selectedDay + 1) + ', ' + this.year
        this.selectedRating = mt.rating
        this.selectedSunrise = mt.strSunrise
        this.selectedSunset = mt.strSunset
        this.majorFeedingTimeOne = mt.strMoonDownPeak
        this.majorFeedingTimeTwo = mt.strMoonUpPeak
        this.minorFeedingTimeOne = mt.strMoonrise
        this.minorFeedingTimeTwo = mt.strMoonset
        this.moonIllumination = mt.moonIllumination + '%'
        this.moonImage = ''
      },
      goToNextMonth(chartData) {
        this.reloading = true
        this.loading = true
        let month = this.month === 12 ? 1 : this.month + 1
        let year = this.month === 12 ? this.year + 1 : this.year
        let lat = chartData.zipCodeHit.latitude
        let long = chartData.zipCodeHit.longitude
        let state = this.state

        axios.get(this.getBaseUrl() + '/chartByMonthYear?month=' + month + '&year=' + year + '&latitude=' + lat + '&longitude=' + long + '&state=' + state).then((response) => {
          this.chart = response.data
          this.options = this.getOptions(this.chart)
          this.rows = this.getRows(this.chart)
          this.reloading = false
        }).catch((error) => {
          console.log(error)
        })
      },
      goToNextYear(chartData) {
        this.reloading = true
        this.loading = true
        let year = this.year + 1
        let lat = chartData.zipCodeHit.latitude
        let long = chartData.zipCodeHit.longitude
        let state = this.state

        axios.get(this.getBaseUrl() + '/chartByMonthYear?month=' + 1 + '&year=' + year + '&latitude=' + lat + '&longitude=' + long + '&state=' + state).then((response) => {
          this.chart = response.data
          this.month = this.chart.moonTimes[1].strMonth
          this.year = this.chart.moonTimes[1].strMonth
          this.options = this.getOptions(this.chart)
          this.rows = this.getRows(this.chart)
          this.reloading = false
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    created: function () {
      window.document.title = 'Lunar Fishing Calendar - Free Solunar Charts'
      let desc = document.getElementById('description')
      desc.content = 'Get a free LUNAR FISHING CALENDAR based on your Zip Code and be a more successful fisherman'
      this.initialize()
    },
    watch: {
      $route: function () {
        this.initialize()
      }
    }
  }

</script>

<style>
  .heading {
    color: #1a54b2;
  }
</style>


// WEBPACK FOOTER //
// ZipcodeChart.vue?4beaf7de